import * as React from "react";
import {Badge} from "@variocube/cube-ui";
import {stylesheet} from "typestyle";
import {useMemo} from "react";
import {useLocalization} from "../i18n";

function isSpecialTag(tag: string): number {
    switch (tag) {
        case "overdue":
            return 1;
        case "redirected":
            return 2;
        case "personal":
            return 3;
        case "department":
            return 4;
        default:
            return 0;
    }
}

function compareTags(a: string, b: string): number {
    const aSpecial = isSpecialTag(a);
    const bSpecial = isSpecialTag(b);
    if(aSpecial && bSpecial) {
        return aSpecial - bSpecial;
    }
    if(aSpecial) {
        return -1;
    }
    if(bSpecial) {
        return 1;
    }
    return a.localeCompare(b);
}

interface DeliveryTagsDisplayProps {
    tags: string[];
    maxTags?: number;
    noWrap?: boolean;
}

export function DeliveryTagsDisplay({tags, maxTags, noWrap}: DeliveryTagsDisplayProps) {
    const {t} = useLocalization();

    const sorted = useMemo<string[]>(() => tags.sort(compareTags), [tags]);
    const display = useMemo<string[]>(() => sorted.slice(0, maxTags), [sorted, maxTags]);
    const more = useMemo<number>(() => (maxTags && sorted.length > maxTags) ? sorted.length - maxTags : 0, [
        sorted,
        maxTags,
    ]);

    return (
        <div className={noWrap ? styles.badgeContainerNoWrap : undefined}>
            {display.map((tag) =>
                <Badge key={tag} className={styles.badgeSpacing}
                       error={tag == "overdue"}
                       warning={tag == "redirected"}
                       success={(tag == "personal" || tag == "department")}>
                    {isSpecialTag(tag) ? t(tag as any) : tag}
                </Badge>
            )}
            {more > 0 && <Badge className={styles.badgeSpacing}>+{more}</Badge>}
        </div>
    );
}

const styles = stylesheet({
    badgeContainerNoWrap: {
        whiteSpace: "nowrap"
    },
    badgeSpacing: {
        marginTop: '0.5em',
        marginRight: '0.5em'
    }
});